{
  "title": "Locations",
  "subtitle": "Your warehouses and stores. Inside each one you can add zones, shelves or bins.",
  "newLocation": "New location",
  "empty": {
    "title": "No location yet",
    "text": "Create your first warehouse, store or depot. Stock is always kept per location."
  },
  "products_one": "{{formatted}} product",
  "products_other": "{{formatted}} products",
  "status": {
    "active": "Active",
    "deactivated": "Deactivated",
    "empty": "Empty"
  },
  "fields": {
    "name": "Name",
    "type": "Type",
    "code": "Code",
    "address": "Address",
    "city": "City",
    "phone": "Phone",
    "responsible": "Responsible"
  },
  "list": {
    "title": "All locations · {{count}}",
    "systemLine": "System · created automatically, read-only",
    "subCount_one": "{{count}} sub-location",
    "subCount_other": "{{count}} sub-locations",
    "deactivatedOn": "Deactivated on {{date}}",
    "footnote": "A location with stock cannot be closed. A location with history is never deleted, only deactivated.",
    "back": "All locations"
  },
  "detail": {
    "system": "System",
    "systemHint": "Goods between two sites during a transfer. Created by the system, it cannot be changed.",
    "inside": "Inside",
    "responsible": "Responsible: {{name}}",
    "productsHere": "Products here",
    "stockValue": "Stock value",
    "attention": "Needs attention",
    "attentionDetail": "{{low}} low · {{over}} over",
    "subLocations": "Sub-locations",
    "addSub": "Add zone, shelf or bin",
    "noSub": "No sub-location. Add zones, shelves or bins when you want to know exactly where things are.",
    "products": "Products",
    "value": "Value (TND)",
    "status": "Status",
    "subHint": "Moving stock between two sub-locations of the same site is done in one step, without “In transit”.",
    "whoCanWork": "Who can work here",
    "nobody": "Nobody is limited to this site yet. Administrators and people with all locations can work here.",
    "isResponsible": "responsible",
    "allLocations": "all locations",
    "manageAccess": "Manage access",
    "close": "Close this location",
    "closeHint": "A location with history is never deleted, only deactivated. First move or issue all its stock so it reaches zero. Its sub-locations close with it.",
    "closeSubHint": "First move all its stock to another place so it reaches zero.",
    "deactivate": "Deactivate",
    "deactivateBlocked": "Deactivate · stock is not zero",
    "deactivateTitle": "Deactivate {{name}}?",
    "deactivateText": "Nobody can use it in operations any more. Its history stays, and you can reactivate it later.",
    "deactivateWithSubs_one": "Its {{count}} active sub-location is deactivated too. Its history stays, and you can reactivate it later.",
    "deactivateWithSubs_other": "Its {{count}} active sub-locations are deactivated too. Their history stays, and you can reactivate them later.",
    "deactivated": "{{name}} deactivated",
    "reopen": "Deactivated location",
    "reopenHint": "Reactivate it to use it again in operations.",
    "reactivate": "Reactivate",
    "reactivated": "{{name}} reactivated",
    "delete": "Delete",
    "deleteTitle": "Delete {{name}}?",
    "deleteText": "This location was never used. It is removed for good; the activity log keeps a record of the deletion.",
    "deleted": "{{name}} deleted",
    "viewStock": "View its stock"
  },
  "form": {
    "newSite": "New location",
    "editSite": "Edit location",
    "newSub": "New zone, shelf or bin in {{site}}",
    "editSub": "Edit sub-location",
    "siteHint": "A warehouse, a store or a depot: a place with its own stock.",
    "subHint": "A precise place inside the site. Stock moves inside a site in one step.",
    "codeHint": "Short, for lists and exports: MAIN, SOU-A.",
    "noResponsible": "Nobody",
    "saved": "Location saved",
    "created": "{{name}} created"
  },
  "access": {
    "title": "Who can work in {{name}}",
    "hint": "People limited to their own locations. Tick the ones who work in this site.",
    "nobody": "Nobody is limited to specific locations. Choose “Only assigned locations” for a person in Users & roles first.",
    "everywhere": "Can work everywhere already: {{names}}",
    "saved": "Access saved"
  }
}
